// settings-validation.js

// Character limit validations
export const validateTitle = (value) => {
  if (value.length > 20) {
    return 'Title must be 20 characters or less';
  }
  return '';
};

export const validateSubtitle = (value) => {
  if (value.length > 60) {
    return 'Subtitle must be 60 characters or less';
  }
  return '';
};

export const validateMetaTitle = (value) => {
  if (value.length > 120) {
    return 'Meta title must be 120 characters or less';
  }
  return '';
};

export const validateMetaDescription = (value) => {
  if (value.length < 120 && value.length > 0) {
    return 'Meta description is too short. Recommended minimum is 120 characters.';
  }
  if (value.length > 160) {
    return 'Meta description is too long. Maximum recommended length is 160 characters.';
  }
  return '';
};

// Input restriction handlers
export const restrictInputLength = (e, maxLength) => {
  if (e.target.value.length >= maxLength && e.key !== 'Backspace' && e.key !== 'Delete') {
    e.preventDefault();
  }
};

// Trim text to maximum length
export const trimToMaxLength = (value, maxLength) => {
  return value.length > maxLength ? value.substring(0, maxLength) : value;
};

// Handle paste event
export const handlePasteWithLimit = (e, maxLength, setValue) => {
  const pastedText = e.clipboardData.getData('text');
  if (pastedText.length > maxLength) {
    e.preventDefault();
    const trimmedText = pastedText.substring(0, maxLength);
    setValue(trimmedText);
  }
};

export const getMetaTitleStatus = (value = '') => {
  const length = value.length;

  if (length === 0) return { color: 'default', message: '' };

  if (length < 50) {
    return {
      color: 'warning',
      message: ` ${length}/60 — Too short. Ideal length is 50–60 characters`
    };
  }

  if (length > 60) {
    return {
      color: 'error',
      message: `${length}/60 — Too long. Must be within 60 characters`
    };
  }

  return {
    color: 'success',
    message: ` ${length}/60 — Ideal length`
  };
};

export const getMetaDescriptionStatus = (value = '') => {
  const length = value.length;

  if (length === 0) return { color: 'default', message: '' };

  if (length < 120) {
    return {
      color: 'warning',
      message: `${length}/160 — Too short. Ideal length is 120–160 characters`
    };
  }

  if (length > 160) {
    return {
      color: 'error',
      message: `${length}/160 — Too long. Must be within 160 characters`
    };
  }

  return {
    color: '#008000',
    message: `${length}/160 — Ideal length`
  };
};
 